import rfdc from 'rfdc';
import isDeeplyEqual from 'fast-deep-equal';
import { sortArray } from '@lx/shared/utils-array';
import { SortingCriteria } from '@lx/shared/types';

const clone = rfdc();

export function deepClone<T>(obj: T): T {
  if (obj === undefined || obj === null) return obj;
  return clone(obj);
}

export function isDeepEqual<T>(objA: T, objB: T): boolean {
  return isDeeplyEqual(objA, objB);
}

export function areArraysEqual<T>(arrA: T[], arrB: T[], sortCriteria?: SortingCriteria<T>): boolean {
  if (arrA?.length !== arrB?.length) {
    return false;
  }

  // Sort arrays, by criteria, before comparison
  const sortedArrA = sortArray(arrA, sortCriteria);
  const sortedArrB = sortArray(arrB, sortCriteria);
  return isDeepEqual(sortedArrA, sortedArrB);
}

export function isEmpty<T>(obj: T): boolean {
  return !obj || (Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype);
}

export const nonNullish = <T>(x: T | null | undefined): x is T => x !== null && x !== undefined;
